import React from 'react'
import GoogleAnalytics from '../GA'

const Title = () => {
    return (
        <div className='w-full xl:w-[1184px]'>
            <h1 className='text-primary-800 font-poppins xsm:font-normal xsm:text-base text-xl font-bold text-left xsm:text-center'>ID Token++ (IDT++) extends the IDT data model by adding support for cryptographic binding to digital wallets, selective disclosure, and issuer identification via WebPKI. It is issued through OIDC Authorization Servers, enabling secure and efficient credential issuance.<a className='font-bold' href="https://github.com/MyNextID/idt-plus-plus" onClick={() => GoogleAnalytics("Title", "link_learnMore", "Link to learn more git")}> Learn more.</a></h1>
        </div>
    )
}

export default Title
